/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.6",
    versionName: "0.2.0-nightly.2026.2.6",
    versionChannel: "nightly",
    buildDate: "2026-02-06T00:09:55.574Z",
    commitHash: "691a16048c73ebcb52b024a9f312d29325338847",
};
